<!--  Copyright (C) 2018 HTC Global Services, Inc. - All Rights Reserved  -->
<router-outlet></router-outlet>
<app-notifications></app-notifications>
<div #popupHolder></div>